import React, { useEffect, useState } from 'react';
import {
  ResponsiveContainer, LineChart, Line, YAxis, Tooltip,
} from 'recharts';
import analyticsService from '../../services/analyticsService';
import type { AnalyticsFilters, RollingWinRateResponse } from '../../types/analytics';

const RollingWinRateSparkline: React.FC<{ filters: AnalyticsFilters }> = ({ filters }) => {
  const [data, setData] = useState<RollingWinRateResponse | null>(null);

  useEffect(() => {
    let cancelled = false;
    analyticsService.getRollingWinRate(filters, 30).then(r => {
      if (!cancelled) setData(r);
    }).catch(() => { /* non-fatal */ });
    return () => { cancelled = true; };
  }, [filters]);

  if (!data || !data.points.length) {
    return <div className="text-xs text-gray-400">Need at least one trade for rolling win-rate.</div>;
  }

  const lastWr = data.points[data.points.length - 1].winRate;

  return (
    <div className="flex items-center gap-4">
      <div>
        <div className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
          Rolling {data.window}-trade win rate
        </div>
        <div className="text-xl font-bold tabular-nums text-gray-900 dark:text-white">
          {lastWr.toFixed(1)}%
        </div>
      </div>
      <div style={{ width: '60%', height: 60 }}>
        <ResponsiveContainer>
          <LineChart data={data.points} margin={{ top: 4, right: 4, left: 4, bottom: 4 }}>
            <YAxis hide domain={[0, 100]} />
            <Tooltip
              formatter={((v: any) => `${Number(v).toFixed(1)}%`) as any}
              contentStyle={{ borderRadius: 6, fontSize: 11 }}
            />
            <Line type="monotone" dataKey="winRate" stroke="#3b82f6" strokeWidth={2} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RollingWinRateSparkline;
